import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cdb0be8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-container" }
const _hoisted_2 = { class: "text-h5 font-weight-black ps-2" }
const _hoisted_3 = { class: "text-subtitle-1 font-weight-regular ps-2" }
const _hoisted_4 = { class: "scrollable-container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_PreviewAppTopBar = _resolveComponent("PreviewAppTopBar")!
  const _component_ThankYouForParticipating = _resolveComponent("ThankYouForParticipating")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { rounded: "lg" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('i18n.preview')), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formObject.form.name), 1)
          ]),
          _createElementVNode("div", null, [
            (_ctx.showNextButton)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  text: _ctx.$t('i18n.next'),
                  location: "start"
                }, _createSlots({ _: 2 }, [
                  (_ctx.showNextButton)
                    ? {
                        name: "activator",
                        fn: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            icon: "mdi-chevron-right",
                            variant: "text",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextFormItem())),
                            size: "x-large"
                          }), null, 16)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["text"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_tooltip, {
              text: _ctx.$t('i18n.resetPreview'),
              location: "start"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  icon: "mdi-restore",
                  variant: "text",
                  onClick: _ctx.resetPreview,
                  size: "x-large"
                }), null, 16, ["onClick"])
              ]),
              _: 1
            }, 8, ["text"]),
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              variant: "text",
              onClick: _ctx.closePreview,
              size: "x-large"
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "overflow-y-auto preview-body text-white" }, {
        default: _withCtx(() => [
          _createVNode(_component_PreviewAppTopBar),
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.showThankYouMessage && _ctx.formObject.form.layout_mode === 'all_on_one_page')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formObject.form_items, (formItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: formItem.id
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentName(formItem)), _mergeProps({ ref_for: true }, _ctx.getComponentProps(formItem, index), { key: _ctx.refreshKey }), null, 16)),
                      (_ctx.formObject.form_items.length > 1 && Number(index) < _ctx.formObject.form_items.length - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (!_ctx.showThankYouMessage && _ctx.formObject.form.layout_mode === 'one_per_page')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.currentFormItemIndex < _ctx.formObject.form_items.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItemsToDisplay.consecutiveTextLabels, (textLabelItem, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: textLabelItem.id
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentName(textLabelItem)), _mergeProps({ ref_for: true }, _ctx.getComponentProps(textLabelItem, index), { key: _ctx.refreshKey }), null, 16)),
                              _hoisted_9
                            ]))
                          }), 128)),
                          (_ctx.formItemsToDisplay.nextInteractiveItem)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentName(_ctx.formItemsToDisplay.nextInteractiveItem)), _mergeProps({ key: 0 }, _ctx.getComponentProps(_ctx.formItemsToDisplay.nextInteractiveItem), { key: _ctx.refreshKey }), null, 16))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
            (_ctx.showThankYouMessage)
              ? (_openBlock(), _createBlock(_component_ThankYouForParticipating, {
                  key: 2,
                  bilingual: _ctx.propBilingual
                }, null, 8, ["bilingual"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "gorate-btn-bg-outlined",
            text: _ctx.$t('i18n.closeBtnText'),
            onClick: _ctx.closePreview,
            variant: "outlined"
          }, null, 8, ["text", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}